const initialState: sage.state.ICreateAnimation = {
    selectedTab: 0,
    selectedAnimationType: null,
    uploadVideoFileStatus: "none",
    uploadVideoProgress: 0,
    fetchVideoJobStatus: "none",
    videoJob: null,
    videoJobId: null,
    hasSeenThirdTab: false,
    hasDownloaded: false,
};

export default function createAnimation(
    state: sage.state.ICreateAnimation = initialState,
    action: sage.actions.createAnimation.ReducerTypes
): sage.state.ICreateAnimation {
    switch (action.type) {
        case "com.sage.actions.createAnimation.ISetAnimationType":
            return {
                ...state,
                selectedAnimationType: action.animationType,
            };
        case "com.sage.actions.createAnimation.ISetTab":
            return {
                ...state,
                selectedTab: action.tab,
            };
        case "com.sage.actions.createAnimation.ISetUploadFileStatus":
            return {
                ...state,
                uploadVideoFileStatus: action.status,
            };
        case "com.sage.actions.createAnimation.ISetUploadVideoProgress":
            return {
                ...state,
                uploadVideoProgress: action.progress,
            };
        case "com.sage.actions.createAnimation.ISetVideoJob":
            return {
                ...state,
                videoJob: action.videoJob,
            };
        case "com.sage.actions.createAnimation.ISetFetchVideoJobStatus":
            return {
                ...state,
                fetchVideoJobStatus: action.status,
            };
        case "com.sage.actions.createAnimation.ISetVideoJobID":
            return {
                ...state,
                videoJobId: action.videoJobId,
            };
        case "com.sage.actions.createAnimation.ISetHasSeenThirdTab":
            return {
                ...state,
                hasSeenThirdTab: action.hasSeen,
            };
        case "com.sage.actions.createAnimation.IHasDownloaded":
            return {
                ...state,
                hasDownloaded: action.hasDownloaded,
            };
        case "com.sage.actions.createAnimation.IStartOver":
            return initialState;
        default:
            return state;
    }
}
